export default {
  computed : {
    per_ledger : function(){
      return this.$store.state.report.per_ledger;
    },

    per_second : function(){
      return !this.per_ledger;
    },

    per_ledger_second_title : function(){
      return this.per_ledger ? 'ledger' : 'second';
    }
  },

  methods : {
    ledgers_to_seconds : function(data, ledgers, period){
      var converted = {}

      Object.keys(data).map(function(k){
        converted[k] = data[k] * ledgers[k] / parseInt(period);
      });

      return converted;
    }
  }
}
